import { ApiService, CommonService, StorageService } from 'src/app/shared/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss'],
  standalone: false
})
export class OtpVerifyComponent implements OnInit, OnDestroy {
  OtpForm: FormGroup;
  submitted = false;
  otp: any;
  userID: any;
  emailID: any;
  role: any;
  bg: any;
  respwebnursepermissions: any;
  permissions: any;
  showOtp = false;
  userdetails: any;
  resendSeconds = 0;
  private readonly RESEND_DELAY = 30;
  private timerId: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly toasterService: ToastrService,
    private readonly spinner: NgxUiLoaderService,
    private readonly commonService: CommonService,
  ) {
    this.OtpForm = this.formBuilder.group({
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    try {
      this.userdetails = JSON.parse(this.storageService.get('userDetail'));
    } catch {
      this.userdetails = null;
    }

    if (!this.userdetails?.userId) {
      this.router.navigate(['/login'], { replaceUrl: true });
    }

    this.startResendTimer();
  }

  onSubmit() {
    this.submitted = true;
    this.otp =
      this.OtpForm.value.otp1 +
      this.OtpForm.value.otp2 +
      this.OtpForm.value.otp3 +
      this.OtpForm.value.otp4;
    if (this.OtpForm.valid) {
      this.apiService
        .postRequest('/account/otp/verify', {
          userId: this.userdetails?.userId,
          otp: this.otp,
        })
        .subscribe((res) => {
          if (res.status) {
            this.storageService.remove('otpPending');
            this.storageService.set('isLoggedIn', 'true')

            this.storageService.set('role', res['data']['role']);

            localStorage.setItem('userId', res['data']['userId']);
            const roleId = res['data']['roleId'];
            this.spinner.start();
            this.apiService
              .getRequest('/manageroles/getRolePermission', { RoleId: roleId })
              .subscribe((Res: any) => {
                this.spinner.stop();
                if (Res['status']) {

                  this.storageService.set('permissions', Res['data'][0]['permission']);
                  this.storageService.set('subCategory', Res['data'][0]['subCategory']);

                  this.commonService.setPermissions();
                }
                this.router.navigate(['/profile-setting']);

              });
          }
        });
    }
  }

  onDigitInput(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '').slice(0, 1);
    this.OtpForm.get(input.id)?.setValue(input.value, { emitEvent: false });

    if (!input.value) return;

    const next = input.nextElementSibling as HTMLInputElement | null;

    if (next?.classList.contains('otp-control')) {
      next.focus();
    } else {
      // last box filled -> go to the Verify button
      document.getElementById('verifyBtn')?.focus();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value) {
      // only jump back when the box is already empty
      (input.previousElementSibling as HTMLInputElement | null)?.focus();
    } else if (event.key === 'ArrowLeft') {
      (input.previousElementSibling as HTMLInputElement | null)?.focus();
    } else if (event.key === 'ArrowRight') {
      const next = input.nextElementSibling as HTMLInputElement | null;
      if (next?.classList.contains('otp-control')) next.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const digits = (event.clipboardData?.getData('text') ?? '')
      .replace(/\D/g, '')
      .slice(0, 4);

    digits.split('').forEach((d, i) => {
      this.OtpForm.get(`otp${i + 1}`)?.setValue(d);
    });

    const lastIndex = Math.min(digits.length, 4);
    if (lastIndex > 0) {
      document.getElementById(`otp${lastIndex}`)?.focus();
    }
  }

  onResend() {
    this.startResendTimer();
    this.apiService
      .postRequest('/account/otp/resend', {
        userId: this.userdetails?.userId,
        isTwoFactorAuthenticationRequired: true,
      })
      .subscribe((res) => {
        if (res.response.status) {
          this.toasterService.success(res.response.message);
        } else {
          this.toasterService.error(res.response.message);
        }
      });
  }

  startResendTimer() {
    this.clearResendTimer();
    this.resendSeconds = this.RESEND_DELAY;
    this.timerId = setInterval(() => {
      this.resendSeconds--;
      if (this.resendSeconds <= 0) {
        this.clearResendTimer();
      }
    }, 1000);
  }

  private clearResendTimer() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  ngOnDestroy(): void {
    this.clearResendTimer();
  }
}
